const imageData=[
    {
        url:"https://res.cloudinary.com/bazeercloud/image/upload/v1710674005/images/durga2_mrnm5c.jpg",
        title:" Ma Durga" ,
        description:"Made in Jaipur marble (Sangemarmar)",
        price:"45,000 rs",
        size:"36 inch (3 feet)",
        
       
    },
    {
        url:"https://res.cloudinary.com/bazeercloud/image/upload/v1710674026/images/shivParivar_cvp6sy.jpg",
        title:"Shiv parivar" ,
        description:"Made in Jaipur marble (Sangemarmar)",
        price:"70,000 rs",
        size:"36 inch (3 feet)",
         
    },
    {
        url:"https://res.cloudinary.com/bazeercloud/image/upload/v1710674021/images/saraswati_l4mjoh.jpg",
        title:"Saraswati" ,
        description:"Made in Jaipur marble (Sangemarmar)",
        price:"45000 rs",
        size:"36 inch (3 feet)"

    },
    

];

export default imageData;